import { STATUS_SUBMIT_HOURS } from 'Pages/TimeTracker/utils/const'
import { MessagesTracker } from '../MessagesTracker'
import { Check, Clock, Warning } from '@phosphor-icons/react'
import { COLOR_BLUE, COLOR_LIGHT_GREEN, COLOR_YELLOW } from 'constant/colors'

// Compact status pill for the tracker's approval state, rendered in the
// Tracker/Timesheet tab row (see Templates/Developer.js) rather than
// Tracker's own toolbar, so it never competes for space with Users /
// Calendars / Start Timer. Resting state stays a one-word label; the full
// message + action lives in the popover, opened only when the user asks for it.
const ApprovalStatusTracker = ({ approval, onSubmit, onDetails }) => {
  const CONFIG_BY_APPROVAL = {
    [STATUS_SUBMIT_HOURS.PENDING]: {
      label: 'Pending',
      title: 'Your daily timesheet has been submitted',
      message: "Please wait for approval. Once approved you won't be able to change anything.",
      textBtn: 'Resubmit',
      onClick: () => onSubmit({ resubmit: true }),
      pillIcon: <Clock size={16} color={COLOR_BLUE} weight="bold" />,
      detailIcon: <Clock size={24} color={COLOR_BLUE} weight="bold" />,
      tone: 'pending'
    },
    [STATUS_SUBMIT_HOURS.REJECTED]: {
      label: 'Not approved',
      title: 'Weekly timesheet not approved',
      message: 'For more information please click on the link. Submit as soon as possible.',
      textBtn: 'More details',
      onClick: onDetails,
      pillIcon: <Warning size={16} color={COLOR_YELLOW} weight="bold" />,
      detailIcon: <Warning size={24} color={COLOR_YELLOW} weight="bold" />,
      tone: 'rejected'
    },
    [STATUS_SUBMIT_HOURS.APPROVED]: {
      label: 'Approved',
      title: 'Weekly timesheet approved',
      message: 'For more information visit payroll.',
      pillIcon: <Check size={16} color={COLOR_LIGHT_GREEN} weight="bold" />,
      detailIcon: <Check size={24} color={COLOR_LIGHT_GREEN} weight="bold" />,
      tone: 'approved'
    }
  }

  const config = CONFIG_BY_APPROVAL[approval]

  if (!config) return null

  return (
    <div className="dropdown approvalStatusTracker mt-2" data-tone={config.tone}>
      <button
        id="approvalStatusTracker"
        type="button"
        className="btn btn-secondary approvalStatusTracker_btn"
        data-bs-toggle="dropdown"
        aria-expanded="false">
        {config.pillIcon}
        <span>{config.label}</span>
      </button>

      <div className="dropdown-menu dropdown-menu-end approvalStatusTracker_menu">
        <MessagesTracker
          title={config.title}
          message={config.message}
          textBtn={config.textBtn}
          onClick={config.onClick}
          icon={config.detailIcon}
        />
      </div>
    </div>
  )
}

export default ApprovalStatusTracker
